import { Route } from "@/types/routes"
import { ACTIVE_ORDERS_PAGE_PATH } from "@/constants/routes"

export const signupRoute: Route = {
  isPublic: true,
  shouldRedirect: ({ isAuth }) => isAuth,
  redirectTo: ({ query }) => ({ newPath: ACTIVE_ORDERS_PAGE_PATH, queryParams: query }),
}
